import { Injectable } from '@angular/core';

@Injectable()
export class UtilsWidgetService {
  constructor() {}

  /**
   * Check if the
   * @param textObject
   * @param action
   * @param key
   */
  static containTooltip(textObject, action, key): string {
    if (textObject && textObject[key]) {
      return textObject[key];
    } else {
      // eslint-disable-next-line
      console.warn(`tooltip not found: ${action}.${key}`);
      return null;
    }
  }
}
